import {
  CLEAR_ERROR,
  FETCH_ACCOUNT,
  FETCH_ACCOUNT_END,
  FETCH_ACCOUNT_ERROR,
  FETCH_ACCOUNT_START,
  SET_TARGET_ACCOUNT,
  UNSET_TARGET_ACCOUNT,
  REMOVE_ACCOUNT,
  FETCH_ACCOUNT_REPORT_START,
  FETCH_ACCOUNT_REPORT,
  FETCH_ACCOUNT_REPORT_ERROR,
  FETCH_ACCOUNT_REPORT_END,
  REMOVE_ACCOUNT_REPORT,
  INITIALIZE_USER,
  INITIALIZE_USER_ERROR,
  FETCH_SWITCH_TYPE_START,
  FETCH_SWITCH_TYPE,
  FETCH_SWITCH_TYPE_ERROR,
  FETCH_SWITCH_TYPE_END,
  CLEAR_SWITCH_TYPE,
} from './types';
import { messages } from '../../util/constants';
import {
  fetchAccount,
  fetchAccountReport,
  fetchSwitchTypeData,
  initializeVAS,
  initializeVOM,
  initializeVZVM,
  initializeVoiceMFE,
  returnHostUrl,
} from '../../util/axiosHelper';
import { base64Encode } from '../../util/pinxtHelpers';
import { switchTypes } from '../../util/constants';

export const fetchCustomerAccounts = criteria => async dispatch => {
  dispatch({
    type: FETCH_ACCOUNT_START,
  });

  try {
    const res = await fetchAccount(criteria);
    const { Accounts } = res.data;

    if (Accounts.length) {
      dispatch({
        type: FETCH_ACCOUNT,
        payload: Accounts,
      });
      if (Accounts.length === 1) {
        dispatch({
          type: SET_TARGET_ACCOUNT,
          payload: {
            chosenAccount: Accounts[0],
            didPickAccount: true,
          },
        });
      }
    } else {
      dispatch({
        type: FETCH_ACCOUNT_ERROR,
        payload: messages.noAccountsMessage,
      });
    }
  } catch (e) {
    let message = e.message;

    if (e.response && e.response.data.message) {
      message = e.response.data.message;
    }

    dispatch({
      type: FETCH_ACCOUNT_ERROR,
      payload: message,
    });
  }

  dispatch({
    type: FETCH_ACCOUNT_END,
  });
};

export const fetchCustomerAccountReport = (
  accountNumber,
  divisionId,
  fromDate,
  toDate,
  accountType
) => async dispatch => {
  dispatch({
    type: FETCH_ACCOUNT_REPORT_START,
  });

  try {
    const res = await fetchAccountReport({
      fromDate,
      toDate,
      accountNumber,
      divisionId,
      accountType,
    });
    const { AccountReports } = res.data;

    dispatch({
      type: FETCH_ACCOUNT_REPORT,
      payload: AccountReports,
    });
  } catch (e) {
    dispatch({
      type: FETCH_ACCOUNT_REPORT_ERROR,
      payload: e.message,
    });
  }

  dispatch({
    type: FETCH_ACCOUNT_REPORT_END,
  });
};

export const removeAccountReport = () => dispatch => {
  dispatch({
    type: REMOVE_ACCOUNT_REPORT,
  });
};

export const clearError = () => dispatch => {
  dispatch({
    type: CLEAR_ERROR,
  });
};

export const removeAccount = () => dispatch => {
  dispatch({
    type: UNSET_TARGET_ACCOUNT,
  });

  dispatch({
    type: REMOVE_ACCOUNT_REPORT,
  });

  dispatch({
    type: REMOVE_ACCOUNT,
  });
};

export const setTargetAccount = (accounts, target) => dispatch => {
  dispatch({
    type: SET_TARGET_ACCOUNT,
    payload: {
      chosenAccount: accounts[target],
      didPickAccount: true,
    },
  });
};

export const unsetTargetAccount = () => dispatch => {
  return dispatch({
    type: UNSET_TARGET_ACCOUNT,
  });
};

export const fetchSwitchType = (accountNumber, divisionId) => async dispatch => {
  dispatch({ type: FETCH_SWITCH_TYPE_START });

  const switch_criteria = {
    params: {
      account: accountNumber,
      division_id: divisionId,
    },
  };

  try {
    const res = await fetchSwitchTypeData(switch_criteria);

    dispatch({
      type: FETCH_SWITCH_TYPE,
      payload: {
        switchType: (res && res.data && res.data.switchType) || switchTypes.METASWITCH,
      },
    });
  } catch (e) {
    dispatch({
      type: FETCH_SWITCH_TYPE_ERROR,
      payload: e.message,
    });
  }

  dispatch({ type: FETCH_SWITCH_TYPE_END });
};

export const clearSwitchType = () => dispatch => {
  dispatch({ type: CLEAR_SWITCH_TYPE });
};

export const redirectToVOMOrVZVM = (guid, dispatch) => {
  if (guid.isVOM) {
    initializeVOM(guid)
      .then(res => {
        const spectrumPortalsHost = returnHostUrl().spectrumPortalsHost;

        window.location.replace(
          `${spectrumPortalsHost}/sign-in-redirect?CODE=${res.data.authCode}&orig_redirect_uri=${
            window.location.origin
          }&state=${base64Encode(
            JSON.stringify({
              targetUrl: 'voice',
              xsrf: localStorage.getItem('centralized_authentication_xsrf'),
              isDla: false,
            })
          )}`
        );
      })
      .catch(e => {
        console.log({ e });

        let message = e.resultMessage || e.message;

        if (e.response && e.response.data.message) {
          message = e.response.data.message;
        }

        dispatch({ type: INITIALIZE_USER_ERROR, payload: message });
      });
  } else {
    initializeVZVM(guid)
      .then(res => {
        window.location.replace(res.data.redirectUrl);
      })
      .catch(e => {
        console.log({ e });

        let message = e.resultMessage || e.message;

        if (e.response && e.response.data.message) {
          message = e.response.data.message;
        }

        dispatch({ type: INITIALIZE_USER_ERROR, payload: message });
      });
  }
};

export const initializeVOMOrVZVM = (guid, dispatch) => {
  if (['chtr', 'charter', 'l-chtr', 'l-charter'].includes(guid.footprint.toLowerCase())) {
    guid.isVOM = [switchTypes.METASWITCH].includes(guid.switchType);
    redirectToVOMOrVZVM(guid, dispatch);
  } else {
    redirectToVOMOrVZVM(guid, dispatch);
  }
};

export const initializeUser = guid => dispatch => {
  dispatch({
    type: INITIALIZE_USER,
  });
  try {
    if (guid.serviceType === 'VoiceMFE') {
      const isSMB = guid.accountType === 'COMMERCIAL';
      initializeVoiceMFE(guid, isSMB)
        .then(res => {
          const host = isSMB ? returnHostUrl().smbPortalsHost : returnHostUrl().spectrumPortalsHost;

          window.location.replace(
            `${host}/sign-in-redirect?CODE=${res.data.authCode}&orig_redirect_uri=${
              window.location.origin
            }&state=${base64Encode(
              JSON.stringify({
                targetUrl: 'services/voice/call-guard?selectedTab=CALLS',
                xsrf: localStorage.getItem('centralized_authentication_xsrf'),
                isDla: false,
              })
            )}`
          );
        })
        .catch(e => {
          console.log({ e });

          let message = e.resultMessage || e.message;

          if (e.response && e.response.data.message) {
            message = e.response.data.message;
          }

          dispatch({ type: INITIALIZE_USER_ERROR, payload: message });
        });
    } else if (guid.serviceType === 'VAS') {
      initializeVAS(guid)
        .then(res => {
          const smbPortalsHost = returnHostUrl().smbPortalsHost;

          window.location.replace(
            `${smbPortalsHost}/sign-in-redirect?CODE=${res.data.authCode}&orig_redirect_uri=${
              window.location.origin
            }&state=${base64Encode(
              JSON.stringify({
                targetUrl: 'internetservices',
                xsrf: localStorage.getItem('centralized_authentication_xsrf'),
                isDla: false,
              })
            )}`
          );
        })
        .catch(e => {
          console.log({ e });

          let message = e.resultMessage || e.message;

          if (e.response && e.response.data.message) {
            message = e.response.data.message;
          }

          dispatch({ type: INITIALIZE_USER_ERROR, payload: message });
        });
    } else {
      initializeVOMOrVZVM(guid, dispatch);
    }
  } catch (e) {
    console.log({ e });
    let message = e.message;

    if (e.response && e.response.data.message) {
      message = e.response.data.message;
    }
    dispatch({
      type: INITIALIZE_USER_ERROR,
      payload: message,
    });
  }
};
